<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>推广管理</span>
          </div>

          <el-form label-width="6em" :inline="true" :model="searchData">
            <el-form-item label="渠道来源">
              <jm-channel
                v-model="searchData.channel"
                clearable
                filterable
              />
            </el-form-item>
            <br />
            <el-form-item label="活动名称">
              <el-select
                filterable
                clearable
                v-model="searchData.ac_id"
                placeholder="-- 请选择 --">
                <el-option v-for="v in actions" :key="v.id" :label="getActionLabel(v)" :value="v.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="二维码类别">
              <el-select
                v-model="searchData.ch_type"
                class="jm-input135"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="{ value, label } in qrTypes"
                  :key="value"
                  :label="label"
                  :value="value"
                >{{ label }}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生成时间">
              <el-date-picker
                :editable="false"
                v-model="dateRange"
                type="daterange"
                unlink-panels
                placeholder="选择日期"
                class="jm-input280"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                class="jm-input-common3"
                type="primary"
                :loading="exporting"
                @click="sendForm">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                class="jm-input-common3"
                type="default"
                @click="resetForm">重置</el-button>
            </el-form-item>
          </el-form>

          <jm-tableList
            url="/training/channel/promotions"
            :refresh.sync="exporting"
            :search-data="searchData"
            class="adminList"
          >
            <el-table-column slot="firstColumn" width="50" label="序号" type="index"></el-table-column>
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              class-name="scope-button-list"
              width="350px"
            >
              <template slot-scope="scope">
                <el-row>
                  <el-button size="mini" type="primary" :disabled="!scope.row.url" @click="copyUrl(scope.row)">复制链接</el-button>
                  <el-button size="mini" type="primary" :disabled="!scope.row.qr_url" @click="alertQrcode(scope.row)">二维码</el-button>
                  <el-button size="mini" type="primary" @click="handleHistory(scope.row)">推广记录</el-button>
                  <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                </el-row>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
    <edit-dialog
      :visible="editDialogVisible"
      :on-cancle="handleEditCancle"
      :initial-value="initialValue"
      :on-submited="handleEditSubmited"
      :qr-types="qrTypes"
      :actions="actions"
    />

    <history-dialog
      :visible="historyDialogVisible"
      :on-cancle="handleHistoryCancle"
      :initial-value="rowData"
      :on-deleted="handleHistoryDeleted"
    />

    <el-dialog
      v-if="isQrcodeVisitle"
      title="推广二维码"
      :visible.sync="isQrcodeVisitle"
      width="400px"
    >
      <div style="text-align:center;">
        <img style="display:inline-block;" :src="currentRow.qr_url" ref="qrImage" />
      </div>
      <div style="text-align:center;">
        <el-button size="mini" type="primary" :download="currentRow.act_title" @click="downloadQrcode">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import jmTableList from '@/components/data/tableList';
import EditDialog from '@/training/components/promotion/editDialog';
import HistoryDialog from '@/training/components/promotion/historyDialog';
import { jmChannel } from '@/components/tool';

export default {
  name: 'PromotionManagement',
  components: {
    jmTableList,
    EditDialog,
    HistoryDialog,
    jmChannel
  },
  data() {
    return {
      dateRange: [],
      searchData: {},
      actions: [],
      exporting: false,
      editDialogVisible: false,
      historyDialogVisible: false,
      initialValue: {},
      qrTypes: [],
      rowData: {},
      current_chid: null,
      isQrcodeVisitle: false,
      currentRow: {}
    };
  },
  created () {
    this.$http._get({
      url: '/training/channel/getAllActionOptions'
    }).then(({ data }) => {
      this.actions = data;
    });
  },
  methods: {
    handleEdit (row) {
      this.initialValue = row;
      this.editDialogVisible = true;
    },
    handleEditCancle () {
      this.editDialogVisible = false;
    },
    handleEditSubmited () {
      this.exporting = true;
      this.editDialogVisible = false;
    },
    handleHistory(row) {
      this.rowData = row;
      this.historyDialogVisible = true;
    },
    handleHistoryCancle () {
      this.historyDialogVisible = false;
    },
    alertQrcode(row) {
      this.isQrcodeVisitle = true;
      this.currentRow = { ...row };
    },
    downloadQrcode() {
      const a = document.createElement('a');
      a.download = this.currentRow.act_title;
      a.href = this.$refs.qrImage.src;
      a.click();
    },
    handleHistoryDeleted() {
      this.exporting = true;
    },
    copyUrl(row) {
      const input = document.createElement('input');
      input.value = row.url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    async getWxAppTypes() {
      const { data } = await this.$http._get({
        url: '/index/api_base/wxapplist',
      });
      this.qrTypes = data;
    },
    sendForm () {
      this.exporting = true;
    },
    resetForm () {
      for (let i = 5; i >= 2; i--) {
        this[`from${i}`] = [];
      }
      this.searchData = {};
      this.searchData.channel = {
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: ''
      };
      this.dateRange = null;
    },
    getActionLabel (action) {
      const title = action.act_title;
      const map = {
        fib: '蓝火 - ',
        job: '求职 - ',
        training: '考培 - '
      };
      const siteName = map[action.site_name] || '';
      return `${siteName}${title}`;
    }
  },
  mounted () {
    this.getWxAppTypes();
  },
  watch: {
    dateRange (value) {
      if (value) {
        const [c1, c2] = value;
        this.searchData.create_time = [
          moment(c1).format('YYYY-MM-DD HH:mm:ss'),
          moment(c2).format('YYYY-MM-DD HH:mm:ss')
        ];
      } else {
        delete this.searchData.create_time;
      }
    },
    searchData: {
      handler () {
        this.searchData = this.searchData.filter((item) => {
          return item !== '';
        });
      },
      deep: true
    }
  },
};
</script>

<style>
</style>
